"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeFirstLevel = exports.isRealObject = void 0;
function isRealObject(obj) {
    return Boolean(obj && typeof obj === 'object' && !Array.isArray(obj));
}
exports.isRealObject = isRealObject;
function mergeFirstLevel(original, update) {
    if (!original) {
        return update;
    }
    const copy = Object.assign({}, original);
    Object.entries(update).forEach(([key, value]) => {
        const originalValue = copy[key];
        // original didn't have the key => add it
        if (!originalValue) {
            copy[key] = value;
            return;
        }
        // non-objects (including) arrays can't be merged => replace original value
        if (!isRealObject(originalValue) || !isRealObject(value)) {
            copy[key] = value;
            return;
        }
        // both original and update contain the key and both values are objects => merge first level
        copy[key] = Object.assign(Object.assign({}, originalValue), value);
    });
    return copy;
}
exports.mergeFirstLevel = mergeFirstLevel;
//# sourceMappingURL=utils.js.map